<p-tabView [(activeIndex)]="activeTab" [scrollable]="true" (onChange)="handleChange($event.index)" 
    [style]="{'margin-top':'20px'}" >
    
    <p-tabPanel >
        <ng-template pTemplate="header">
            <i class="pi pi-circle-on">
                <h5>Todos</h5>
            </i>
        </ng-template>
        <app-chat-list [data]="chats" (opencChat)="changeSh()"></app-chat-list>
    </p-tabPanel>
    <p-tabPanel *ngFor="let statu of estatus">
        <ng-template pTemplate="header">
            <i class="{{statu.icon}}">
                <h5>{{statu.name}}</h5>
            </i>
        </ng-template>
        <app-chat-list [data]="chats" (opencChat)="changeSh()"></app-chat-list>
    </p-tabPanel>

    
    
    <!-- <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="pi pi-circle-off pb-0" ><h5 >Todos</h5></i>
        </ng-template>
        <app-chat-list [data]="chats" (opencChat)="changeSh()"></app-chat-list>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="pi pi-clock pb-0" ><h5 class="mL--15">Pendientes</h5></i>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="pi pi-comments pb-0" ><h5 class="mL--15">Chats</h5></i>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="pi pi-check-circle pb-0" ><h5 class="mL--15">Resueltos</h5></i>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span>
                <i class="pi pi-trash pb-0"><h5 class="mL--15">Eliminados</h5></i>
            </span>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span>
                <i class="pi pi-volume-off pb-0"><h5 class="mL--15">Silenciados</h5></i>
            </span>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span>
                <i class="pi pi-chevron-circle-down pb-0"><h5 class="mL--15">No leídos</h5></i>
            </span>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span>
                <i class="pi pi-check-circle pb-0"><h5 class="mL--15">Asignados</h5></i>
            </span>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span>
                <i class="pi pi-inbox pb-0"><h5 class="mL--15">Archivados</h5></i>
            </span>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span>
                <i class="pi pi-times-circle pb-0"><h5 class="mL--15">Bloqueados</h5></i>
            </span>
        </ng-template>
        <ng-template pTemplate="content">
            <app-chat-list [data]="chats"></app-chat-list>
        </ng-template>
    </p-tabPanel> -->

</p-tabView>